import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './store/store'
import { Provider } from 'react-redux'
import { loadStripe } from '@stripe/stripe-js';
import {Elements } from '@stripe/react-stripe-js';
const root = ReactDOM.createRoot(document.getElementById('root'));
const stripePromise = loadStripe('sk_test_51Pt4dJIFqGjST8kI2Qdk0nn84J66eyHSGb1EhVgVX9te61jj2pDGjIAiEFvMHCkobROL3IaXUZG2DFyeaXhKKfQ400kliKkOaj');

root.render(
  <Elements stripe={stripePromise}>
  <Provider store={store}>
    <App />
  </Provider>
  </Elements>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
